<template>
  <div class="flex flex-col items-center justify-between">
    <!-- banner -->
    <div class="relative flex flex-col h-[530px] w-full text-center">
      
      <div class="relative flex flex-col flex justify-evenly items-left self-center w-full max-w-[1200px] pt-[350px]">
        <p class="font-serif font-bold text-[3rem] text-[7rem] text-left" style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;">
          {{ $t('terms.title') }}</p>
      </div>

      <div class="absolute top-[0%] right-[0%] bottom-[0%] left-[0%] w-full h-full z-[-1]">
        <div class="flex flex-row justify-center items-stretch w-full h-full overflow-hidden">
          <video ref="bannerVideo" muted autoplay loop  playsinline 
          poster="@/assets/index/img/index/poster-hero.jpeg"
          class="aspect-video w-full h-full object-fill cursor-pointer">
            <source src="@/assets/index/img/index/default2.mp4" type="video/mp4">
            Your browser does not support
          </video>
        </div>
      </div>
    </div>
    <section class="flex flex-row justify-between w-full">
        <div class="w-[20%]"></div>
        <div class="w-[60%] mb-[68px]">
          <p class="text-[#333333] text-[1.5rem] font-bold my-[20px]">{{ $t('terms.last_updated') }}</p>
          <div class="content min-h-[1000px]" v-html="info"></div>
        </div>
        <div class="w-[5%]"></div>
    </section>
  </div>
</template>

<script>
import {getTerms_conditions} from '@/http/api/home'

export default {
  name: 'terms',
  data(){
    return {
      info:''
    }
  },
  created() {
    this.init()
  },
  methods:{
    async init(){
      try {
        const res = await getTerms_conditions()
        this.info = typeof res.data === 'string' ? res.data : ''
      } catch (e) {
        this.info = ''
        this.$message.error(this.$t('terms.message.load_fails'))
      }
    }
  }
}
</script>
<style lang="scss">
  span,p{
    font-family: myPingFang!important;
  }
</style>
<style lang="scss" scoped>
.content{line-height: 1.7}
</style>
